import { render, staticRenderFns } from "./ForgotDialog.vue?vue&type=template&id=50e0e488&"
import script from "./ForgotDialog.vue?vue&type=script&lang=js&"
export * from "./ForgotDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports